import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import styles from './Dashboard.module.css';

const OperatorDashboard = ({ onNavigateToMap }) => {
  const { user, userRole, logout } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Genel Bakış', icon: '' },
    { id: 'maintenance', label: 'Bakım Görevleri', icon: '' },
    { id: 'alerts', label: 'Uyarılar', icon: '' },
    { id: 'quick-actions', label: 'Hızlı İşlemler', icon: '' },
  ];

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.dashboardHeader}>
        <div>
          <h1>Operator Dashboard</h1>
          <p>Hoş geldiniz, {user?.email || user?.username}</p>
          <p className={styles.roleBadge}>Rol: {userRole}</p>
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <button 
            onClick={logout}
            className={styles.logoutButton}
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
              transition: 'all 0.3s',
            }}
            onMouseEnter={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.2)';
            }}
          >
            Çıkış Yap
          </button>
        </div>
      </div>

      <div className={styles.dashboardTabs}>
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`${styles.tabButton} ${activeTab === tab.id ? styles.active : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className={styles.tabIcon}>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.dashboardContent}>
        {activeTab === 'overview' && (
          <div className={styles.overviewContainer}>
            <div className={styles.overviewHeader}>
              <h2>Genel Bakış</h2>
              <button 
                onClick={onNavigateToMap}
                className={styles.mapButton}
              >
                <span className={styles.mapButtonIcon}></span>
                Harita Üzerinden İnceleme Yap
              </button>
            </div>
            <div className={styles.overviewCards}>
              <div className={styles.overviewCard}>
                <h3>Aktif Bakım Görevleri</h3>
                <p className={styles.cardValue}>5</p>
                <p className={styles.cardLabel}>Bekleyen</p>
              </div>
              <div className={styles.overviewCard}>
                <h3>Acil Uyarılar</h3>
                <p className={styles.cardValue}>2</p>
                <p className={styles.cardLabel}>Müdahale gereken</p>
              </div>
              <div className={styles.overviewCard}>
                <h3>Bu Ay Tamamlanan</h3>
                <p className={styles.cardValue}>18</p>
                <p className={styles.cardLabel}>Bakım işlemi</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'maintenance' && (
          <div className={styles.maintenanceContainer}>
            <div className={styles.maintenanceHeader}>
              <h2>Bakım Görevleri</h2>
              <button className={styles.addButton}>+ Yeni Görev</button>
            </div>
            
            <div className={styles.maintenanceList}>
              <div className={styles.maintenanceItem}>
                <div className={styles.maintenanceInfo}>
                  <h3>Pompa İstasyonu #1 - Acil Bakım</h3>
                  <p>Konum: Merkez Bölge | Tarih: 12.04.2024 | Öncelik: Yüksek</p>
                  <span className={styles.statusBadge}>Acil</span>
                </div>
                <div className={styles.maintenanceActions}>
                  <button className={styles.actionButton}>Detaylar</button>
                  <button className={styles.actionButton}>Başlat</button>
                </div>
              </div>
              
              <div className={styles.maintenanceItem}>
                <div className={styles.maintenanceInfo}>
                  <h3>Filtre Sistemi #3 - Periyodik Kontrol</h3>
                  <p>Konum: Güney Bölge | Tarih: 15.04.2024 | Öncelik: Orta</p>
                  <span className={styles.statusBadge}>Beklemede</span>
                </div>
                <div className={styles.maintenanceActions}>
                  <button className={styles.actionButton}>Detaylar</button>
                  <button className={styles.actionButton}>Başlat</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'alerts' && (
          <div className={styles.alertsContainer}>
            <div className={styles.alertsHeader}>
              <h2>Sistem Uyarıları</h2>
            </div>
            
            <div className={styles.alertsList}>
              <div className={styles.alertItem} style={{ borderLeft: '4px solid #ef4444' }}>
                <div className={styles.alertIcon}></div>
                <div className={styles.alertInfo}>
                  <h3>Yüksek Basınç Uyarısı</h3>
                  <p>Pompa İstasyonu #1 - Basınç seviyesi kritik seviyede</p>
                  <span className={styles.alertTime}>2 saat önce</span>
                </div>
                <button className={styles.actionButton}>İncele</button>
              </div>
              
              <div className={styles.alertItem} style={{ borderLeft: '4px solid #f59e0b' }}>
                <div className={styles.alertIcon}></div>
                <div className={styles.alertInfo}>
                  <h3>Düşük Su Seviyesi</h3>
                  <p>Su Deposu #2 - Su seviyesi %30'un altında</p>
                  <span className={styles.alertTime}>5 saat önce</span>
                </div>
                <button className={styles.actionButton}>İncele</button>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'quick-actions' && (
          <div className={styles.quickActionsContainer}>
            <div className={styles.quickActionsHeader}>
              <h2>Hızlı İşlemler</h2>
            </div>
            
            <div className={styles.quickActionsGrid}>
              <button className={styles.quickActionCard}>
                <div className={styles.quickActionIcon}></div>
                <h3>Bakım Raporu Oluştur</h3>
                <p>Yeni bakım işlemi için rapor oluştur</p>
              </button>
              
              <button className={styles.quickActionCard}>
                <div className={styles.quickActionIcon}></div>
                <h3>Fotoğraf Yükle</h3>
                <p>Bakım öncesi/sonrası fotoğrafları ekle</p>
              </button>
              
              <button className={styles.quickActionCard}>
                <div className={styles.quickActionIcon}></div>
                <h3>Envanter Kontrolü</h3>
                <p>Yedek parça ve malzeme durumunu kontrol et</p>
              </button>
              
              <button className={styles.quickActionCard}>
                <div className={styles.quickActionIcon}></div>
                <h3>Destek Talebi</h3>
                <p>Teknik destek veya yardım talebi oluştur</p>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OperatorDashboard;

